import { render, staticRenderFns } from "./OrderInfoPages.vue?vue&type=template&id=6d826d9d&"
import script from "./OrderInfoPages.vue?vue&type=script&lang=js&"
export * from "./OrderInfoPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports